var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClicaTimelineIcuida(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Clica_Timeline_icuida",
    xmlns: "http://www.w3.org/2000/svg",
    width: 109.898,
    height: 122.693,
    viewBox: "0 0 109.898 122.693",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1186",
    "data-name": "Grupo 1186",
    transform: "translate(-118.047 -12.428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1184",
    "data-name": "Grupo 1184"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_185",
    "data-name": "Elipse 185",
    cx: 46.544,
    cy: 46.544,
    r: 46.544,
    transform: "translate(119.594 105.701) rotate(-80.679)",
    fill: "#8ccee1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_186",
    "data-name": "Elipse 186",
    cx: 38.808,
    cy: 38.808,
    r: 38.808,
    transform: "translate(118.181 67.31) rotate(-45)",
    fill: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Clica",
    transform: "translate(149.659 89.725)",
    fill: "#fff",
    fontSize: 17.442,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Clica"))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1185",
    "data-name": "Grupo 1185"
  }, /*#__PURE__*/React.createElement("text", {
    id: "iCuida_Comienza...",
    "data-name": "iCuida Comienza...",
    transform: "translate(140.287 47.016)",
    fontSize: 12,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "iCuida "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 25.4
  }, "Comienza..."))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_826",
    "data-name": "Trazado 826",
    d: "M192.666,84.479h6.986v2.3h-6.986Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_827",
    "data-name": "Trazado 827",
    d: "M197.254,94.947l-6.261-2.92.973-2.087,6.261,2.92Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_828",
    "data-name": "Trazado 828",
    d: "M197.255,76.313l.973,2.087-6.262,2.92-.973-2.087Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1187",
    "data-name": "Grupo 1187",
    transform: "translate(-118.047 -12.428)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_TIMELINE",
    "data-name": " TIMELINE",
    transform: "translate(118.047 131.121)",
    fill: "#1a1a1a",
    fontSize: 16,
    fontFamily: "Montserrat-Light, Montserrat",
    fontWeight: 300,
    letterSpacing: "0.2em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, " TIMELINE")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClicaTimelineIcuida);
export default __webpack_public_path__ + "static/media/Clica_Timeline_icuida.00e9de0497252c003aa560b9c590e3d1.svg";
export { ForwardRef as ReactComponent };